import { cache } from "react"
import directusServer from "./directus/directusGraphQLInstance"
import { rethrowIfDatabaseUnavailable } from "./errors/database"

const getAllCategories = cache(
  async ({ limit, page }: { limit?: number; page?: number } = {}) => {
    try {
      const response = await directusServer.query(
        `
			 query getAllCategories($page: Int, $limit: Int) {
				category(
					sort:  "-slug",
					filter: { status: { _eq: "published" } }
					page: $page,
					limit: $limit,
				) {
						id
						image {
							id
							width
							filename_download
							height
						}
						slug
						title
						description
					}
				}
			`,
        {
          limit: limit,
          page: page,
        }
      )

      // console.log(response);

      return response
    } catch (error) {
      rethrowIfDatabaseUnavailable(error)
      console.error(error)
      return null
    }
  }
)

export default getAllCategories
